import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router";
import DashboardLayout from "../../../Layouts/Dashboard/dashboard";
import { GetUnreadMessages } from "../../../Redux/Reducers/redux-slice-group-messages";
import { routePaths } from "../../../Router/router";
import { useMemo, useState } from "react";
import DashboardApprovalsBanner from "../../../Components/Banners/DashboardApprovalsBanner";
import { DbUserAclElevationWishlistInfos } from "../../../Core/Api/Types/db-user-acl-elevation-wishlist-infos";
import SelectModeSubbarOpener from "../../../Components/Banners/SelectModeBanner/opener";
import WorkflowBanner from "../../../Components/Banners/WorkflowBanner";
import { Stack } from "@mui/system";

function Dashboard() {
    const location = useLocation();

    const curPath = location.pathname.toString();
    let isWorkflows = curPath === routePaths.dashboardQC.path;
    const [selectedApprovals, setSelectedApprovals] = useState<DbUserAclElevationWishlistInfos[]>([]);
    const [selectedItems, setSelectedItems] = useState<any[]>([]);

    const handleCloseClick = () => {
        setSelectedApprovals([]);
        setSelectedItems([]);
    };

    const _Banner = useMemo(() => {
        if (curPath === routePaths.dashboardApprovals.path)
            return <DashboardApprovalsBanner items={selectedApprovals} handleCloseClick={handleCloseClick} />;

        if (curPath === routePaths.dashboardQC.path)
            return <WorkflowBanner wks={selectedItems} handleCloseClick={handleCloseClick} />;

        return undefined;
    }, [curPath, selectedApprovals, selectedItems]);

    return (
        <DashboardLayout
            sxContent={{ px: 2 }}
            withContainer={false}
            noScroll
            Banner={_Banner}
        >
            <Stack width="100%" flexDirection="column" flex="1 1 0%" minHeight={0}>
                <Outlet
                    context={{
                        selectedApprovals: selectedApprovals,
                        setSelectedApprovals: setSelectedApprovals,
                        selectedItems: selectedItems,
                        setSelectedItems: setSelectedItems,
                    }}
                />
            </Stack>

            <SelectModeSubbarOpener
                selectedObjects={isWorkflows ? selectedItems.map((s) => s.id) : selectedApprovals.map((s) => s.id)}
            />
        </DashboardLayout>
    );
}

export default Dashboard;
